import { AddressStreetSetRequest } from "@1games-ru/region-shared/dist/backend/requests/address";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useAddressStreetSet() {
  const mutateAsync = useCallback(async (data: AddressStreetSetRequest) => {
    try {
      const response = await CreateEntityMpProvider.addressStreetSet(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Улица успешно сохранена");
        return response.data;
      }

      console.log({ data, response });
      toast.error("Ошибка сохранения улицы");
      return false;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка сохранения улицы");
      return false;
    }
  }, []);

  return {
    mutateAsync,
  };
}
